import { createContext } from 'preact';

export type ConveyorBeltContextProps = {
  setCurrentItem?: (node: HTMLElement | null) => void;
};

export const ConveyorBeltContext = createContext<ConveyorBeltContextProps>({});
